import React from 'react'
import { Link } from 'react-router-dom'

export const Contact = () => {
  return (
    <main>
      {/* Page banner */}
      <div className="page-banner">
        {/* Decorative background icons */}
        <i className="banner-deco-icon fa-solid fa-phone"        style={{ top: '18%',  left: '6%',  fontSize: '3.5rem', transform: 'rotate(-15deg)' }}></i>
        <i className="banner-deco-icon fa-solid fa-envelope"     style={{ top: '55%',  left: '14%', fontSize: '2.4rem', transform: 'rotate(10deg)'  }}></i>
        <i className="banner-deco-icon fa-solid fa-headset"      style={{ top: '20%',  right: '8%', fontSize: '3.8rem', transform: 'rotate(12deg)'  }}></i>
        <i className="banner-deco-icon fa-solid fa-comment-dots" style={{ top: '58%',  right: '5%', fontSize: '2.6rem', transform: 'rotate(-8deg)'  }}></i>
        <i className="banner-deco-icon fa-solid fa-location-dot" style={{ top: '22%', left: '50%', fontSize: '2rem',   transform: 'translateX(-50%) rotate(5deg)' }}></i>

        <div className="page-banner-overlay">
          <h1 className="page-banner-title">Contact Us</h1>
          <nav className="page-breadcrumb" aria-label="breadcrumb">
            <Link to="/" className="breadcrumb-link">Home</Link>
            <span className="breadcrumb-sep"><i className="fa-solid fa-chevron-right"></i></span>
            <span className="breadcrumb-current">Contact Us</span>
          </nav>
        </div>
      </div>

      <section className="contact-section">
        <div className="contact-wrapper">
          <h2 className="contact-heading">Contact Us</h2>
          <p className="contact-subheading">
            Get in touch with us for PLC automation and electrical support
            services
          </p>

          <div className="contact-card">
            <div className="contact-avatar">
              <i className="fa-solid fa-user-tie"></i>
            </div>

            <h3 className="contact-name">Kamal Pahadiya</h3>

            <div className="contact-details">
              <div className="contact-row">
                <div className="contact-icon-wrap">
                  <i className="fa-solid fa-envelope"></i>
                </div>
                <div>
                  <span className="contact-label">Email</span>
                  <a
                    href="mailto:support@gaurangengineering.co.in"
                    className="contact-value"
                  >
                    support@gaurangengineering.co.in
                  </a>
                </div>
              </div>

              <div className="contact-row">
                <div className="contact-icon-wrap">
                  <i className="fa-solid fa-phone"></i>
                </div>
                <div>
                  <span className="contact-label">Mobile</span>
                  <a href="tel:+918058924298" className="contact-value">
                    +91 80589 24298
                  </a>
                  <a href="tel:+919414770666" className="contact-value">
                    +91 94147 70666
                  </a>
                </div>
              </div>
              <div className="contact-row">
                <div className="contact-icon-wrap">
                  <i className="fa-solid fa-location-dot"></i>
                </div>
                <div>
                  <span className="contact-label">Address</span>
                  <span className="contact-value">
                    GAURANG ENGINEERING SERVICES<br />
                    181/212, Pratap Nagar Sanganer<br />
                    Jaipur 302033, Rajasthan
                  </span>
                </div>
              </div>

              <div className="contact-row">
                <div className="contact-icon-wrap">
                  <i className="fa-solid fa-map"></i>
                </div>
                <div>
                  <span className="contact-label">Location</span>
                  <a
                    href="https://google.com/maps?q=26.8019029,75.8315786&z=17&hl=en"
                    className="contact-value contact-map-link"
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    <i className="fa-solid fa-arrow-up-right-from-square"></i>
                    Open in Google Maps
                  </a>
                </div>
              </div>

              <div className="contact-row">
                <div className="contact-icon-wrap">
                  <i className="fa-solid fa-building-columns"></i>
                </div>
                <div>
                  <span className="contact-label">GSTIN</span>
                  <span className="contact-value contact-id">08APTPP1107P1Z9</span>
                </div>
              </div>

              <div className="contact-row">
                <div className="contact-icon-wrap">
                  <i className="fa-solid fa-id-card"></i>
                </div>
                <div>
                  <span className="contact-label">PAN No.</span>
                  <span className="contact-value contact-id">APTPP1107P</span>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
    </main>
  )
}
